<template>
  <div class="main-box commission-check">
    <el-form class="form-inline" :inline="true" size="small">
      <el-form-item>
        <el-input
          v-model="search.keywords"
          class="keyword-input"
          placeholder="请输入充值订单号或消费订单号"
          clearable
          @keyup.enter.native="handleSearch">
          <el-button slot="append" type="primary" @click="handleSearch">查询</el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-empty v-if="info && totalCount === 0" description="没有查到关联记录"></el-empty>

    <div v-if="info && totalCount > 0">
      <div class="account-header">
        <div>
          <div class="eyebrow">核对单号</div>
          <h2>{{ info.keywords }}</h2>
        </div>
        <el-tag :type="summaryType(info.summary.status)" effect="dark">
          {{ summaryText(info.summary.status) }}
        </el-tag>
      </div>

      <div class="flow-board">
        <div class="flow-step">
          <div class="step-title">1. 充值进来</div>
          <div class="step-main">{{ money(flowSummary.rechargeIntegral) }} 积分</div>
          <div class="step-sub">{{ flowSummary.rechargeMember || '-' }}</div>
        </div>
        <div class="flow-arrow">→</div>
        <div class="flow-step">
          <div class="step-title">2. 后续消费</div>
          <div class="step-main">{{ money(flowSummary.usedIntegral) }} 积分</div>
          <div class="step-sub">{{ listLength('orders') }} 笔消费订单</div>
        </div>
        <div class="flow-arrow">→</div>
        <div class="flow-step">
          <div class="step-title">3. 拆出业绩</div>
          <div class="step-main">￥{{ money(flowSummary.detailCommission) }}</div>
          <div class="step-sub">业绩池 ￥{{ money(flowSummary.poolCommission) }}</div>
        </div>
        <div class="flow-arrow">→</div>
        <div class="flow-step">
          <div class="step-title">4. 结算/退款</div>
          <div class="step-main">已到账 ￥{{ money(flowSummary.settleCommission) }}</div>
          <div class="step-sub">待结算 ￥{{ money(flowSummary.pendingCommission) }}，退款扣 ￥{{ money(flowSummary.refundCommission) }}</div>
        </div>
      </div>

      <div class="summary-grid">
        <summary-card title="充值积分" :value="money(flowSummary.rechargeIntegral)" unit="积分"></summary-card>
        <summary-card title="已消费积分" :value="money(flowSummary.usedIntegral)" unit="积分"></summary-card>
        <summary-card title="剩余有效积分" :value="money(flowSummary.remIntegral)" unit="积分"></summary-card>
        <summary-card title="退回积分" :value="money(flowSummary.refundIntegral)" unit="积分"></summary-card>
        <summary-card title="业绩池总额" :value="money(flowSummary.poolCommission)" unit="元"></summary-card>
        <summary-card title="已结算到账" :value="money(flowSummary.settleCommission)" unit="元"></summary-card>
        <summary-card title="待结算" :value="money(flowSummary.pendingCommission)" unit="元"></summary-card>
        <summary-card title="退款扣除业绩" :value="money(flowSummary.refundCommission)" unit="元"></summary-card>
      </div>

      <div class="section-block">
        <div class="section-head">
          <h3>资金/业绩走向</h3>
          <el-tag size="mini">{{ orderFlows.length }} 笔消费订单</el-tag>
        </div>

        <div v-if="orderFlows.length === 0" class="empty-panel">
          这笔充值还没有关联消费订单。当前只产生了充值积分和业绩池。
        </div>

        <div v-for="order in orderFlows" :key="order.id" class="order-flow" :class="{ error: order.status === 'error' }">
          <div class="order-head">
            <div>
              <div class="order-title">消费订单 {{ order.order_sn }}</div>
              <div class="order-meta">
                下单用户：{{ order.member }}　订单状态：{{ order.status_name }}　支付时间：{{ order.pay_time || '-' }}
              </div>
            </div>
            <el-tag :type="order.status === 'normal' ? 'success' : 'danger'">
              {{ order.status === 'normal' ? '正常' : '异常' }}
            </el-tag>
          </div>

          <div class="order-lines">
            <div class="money-line">
              <div class="line-label">积分消耗</div>
              <div class="line-content">
                本单使用 <strong>{{ money(order.use_integral) }}</strong> 积分。
                <span v-for="goods in order.goods" :key="goods.id" class="muted">
                  {{ goods.goods_name }} x {{ goods.quantity }}，已退 {{ goods.refund_quantity }}，用 {{ money(goods.use_integral) }} 积分。
                </span>
              </div>
            </div>
            <div class="money-line">
              <div class="line-label">业绩拆分</div>
              <div class="line-content">
                按公式应拆 ￥{{ money(order.expectedCommission) }}，实际拆出 ￥{{ money(order.detailCommission) }}。
                <span class="formula">公式：业绩池 × 本单使用积分 / 充值积分</span>
              </div>
            </div>
            <div class="money-line">
              <div class="line-label">结算到账</div>
              <div class="line-content">
                明细已结算 ￥{{ money(order.settleCommission) }}，业绩流水到账 ￥{{ money(order.billCommission) }}，待结算 ￥{{ money(order.pendingCommission) }}。
              </div>
            </div>
            <div class="money-line">
              <div class="line-label">退款影响</div>
              <div class="line-content">
                退回积分 {{ money(order.refundIntegral) }}，退款扣佣 ￥{{ money(order.refundCommission) }}。
              </div>
            </div>
          </div>

          <div class="check-row">
            <check-tags :checks="order.checks"></check-tags>
          </div>
        </div>
      </div>

      <div class="section-block" v-if="errorChecks.length > 0">
        <div class="section-head">
          <h3>异常位置</h3>
          <el-tag type="danger" size="mini">{{ errorChecks.length }}</el-tag>
        </div>
        <div class="error-list">
          <div v-for="(item, index) in errorChecks" :key="index" class="error-item">
            <el-tag type="danger" size="mini">异常</el-tag>
            <span>{{ item.scope }}：{{ item.title }}，{{ item.message }}</span>
          </div>
        </div>
      </div>

      <el-collapse class="raw-collapse">
        <el-collapse-item title="原始记录明细" name="raw">
          <raw-section title="充值积分记录" :rows="getList('integrals')"></raw-section>
          <raw-section title="业绩池 order_commission" :rows="getList('commissions')"></raw-section>
          <raw-section title="消费订单" :rows="getList('orders')"></raw-section>
          <raw-section title="订单业绩明细 order_commission_detail" :rows="getList('details')"></raw-section>
          <raw-section title="业绩流水 member_commission_detail" :rows="getList('bills')"></raw-section>
          <raw-section title="退款记录 order_refund" :rows="getList('refunds')"></raw-section>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
const CheckTags = {
  props: {
    checks: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    tagType(status) {
      return status === 'normal' ? 'success' : (status === 'warning' ? 'warning' : 'danger')
    },
    tagText(status) {
      return status === 'normal' ? '正常' : (status === 'warning' ? '注意' : '异常')
    }
  },
  template: `
    <div class="check-tags">
      <el-tooltip
        v-for="(item, index) in checks"
        :key="index"
        :content="item.message || item.title"
        placement="top">
        <el-tag :type="tagType(item.status)" size="mini" class="check-tag">
          {{ tagText(item.status) }}：{{ item.title }}
        </el-tag>
      </el-tooltip>
    </div>
  `
}

const SummaryCard = {
  props: {
    title: String,
    value: [String, Number],
    unit: String
  },
  template: `
    <div class="summary-card">
      <span>{{ title }}</span>
      <strong>{{ value }}</strong>
      <em>{{ unit }}</em>
    </div>
  `
}

const RawSection = {
  props: {
    title: String,
    rows: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    preview(row) {
      return JSON.stringify(row, null, 2)
    }
  },
  template: `
    <div class="raw-section">
      <div class="raw-title">{{ title }}（{{ rows.length }}）</div>
      <pre v-for="row in rows" :key="title + row.id">{{ preview(row) }}</pre>
    </div>
  `
}

export default {
  components: {
    CheckTags,
    SummaryCard,
    RawSection
  },
  data() {
    return {
      search: {
        keywords: ''
      },
      info: false
    };
  },
  created() {
    if (this.$route.query.keywords) {
      this.search.keywords = this.$route.query.keywords
      this.getInfo()
    }
  },
  computed: {
    totalCount() {
      if (!this.info) {
        return 0
      }
      return this.listLength('integrals') + this.listLength('commissions') + this.listLength('orders') + this.listLength('details') + this.listLength('bills') + this.listLength('refunds')
    },
    flowSummary() {
      var integrals = this.getList('integrals')
      var commissions = this.getList('commissions')
      var details = this.getList('details')
      var bills = this.getList('bills')
      var refunds = this.getList('refunds')

      return {
        rechargeMember: integrals[0] ? integrals[0].member : '',
        rechargeIntegral: this.sum(integrals, 'change_integral'),
        usedIntegral: this.sum(integrals, 'used_integral'),
        remIntegral: this.sum(integrals, 'rem_integral'),
        refundIntegral: this.sum(refunds, 'integral'),
        poolCommission: this.sum(commissions, 'commission'),
        detailCommission: this.sum(details, 'commission'),
        settleCommission: this.sum(details, 'settle_commission'),
        refundCommission: this.sum(details, 'refund_commission') + this.sum(commissions, 'refund_commission'),
        pendingCommission: this.sum(commissions, 'pending_commission'),
        billCommission: this.sum(bills, 'change_amount')
      }
    },
    orderFlows() {
      var that = this
      return this.getList('orders').map(function (order) {
        var details = that.getList('details').filter(function (item) {
          return Number(item.order_id) === Number(order.id)
        })
        var bills = that.getList('bills').filter(function (item) {
          return item.order_sn === order.order_sn
        })
        var refunds = that.getList('refunds').filter(function (item) {
          return item.order_sn === order.order_sn
        })
        var checks = []
        details.forEach(function (item) {
          checks = checks.concat(item.checks || [])
        })
        var status = checks.some(function (item) {
          return item.status === 'error'
        }) ? 'error' : 'normal'

        return Object.assign({}, order, {
          details: details,
          bills: bills,
          refunds: refunds,
          expectedCommission: that.sum(details, 'expected_commission'),
          detailCommission: that.sum(details, 'commission'),
          settleCommission: that.sum(details, 'settle_commission'),
          refundCommission: that.sum(details, 'refund_commission'),
          pendingCommission: that.sum(details, 'pending_commission'),
          billCommission: that.sum(bills, 'change_amount'),
          refundIntegral: that.sum(refunds, 'integral'),
          checks: checks.length ? checks : [{ status: 'normal', title: '本单链路未发现异常', message: '积分消耗、业绩拆分、结算流水和退款记录已核对' }],
          status: status
        })
      })
    },
    errorChecks() {
      var rows = []
      this.getList('integrals').forEach(function (item) {
        (item.checks || []).forEach(function (check) {
          if (check.status === 'error') {
            rows.push(Object.assign({ scope: '充值积分 ' + item.order_sn }, check))
          }
        })
      })
      this.getList('commissions').forEach(function (item) {
        (item.checks || []).forEach(function (check) {
          if (check.status === 'error') {
            rows.push(Object.assign({ scope: '业绩池 #' + item.id }, check))
          }
        })
      })
      this.getList('details').forEach(function (item) {
        (item.checks || []).forEach(function (check) {
          if (check.status === 'error') {
            rows.push(Object.assign({ scope: '订单业绩明细 #' + item.id }, check))
          }
        })
      })
      return rows
    }
  },
  methods: {
    getInfo() {
      var that = this
      if (that.search.keywords.trim() === '') {
        that.tips('请输入充值订单号或消费订单号')
        return false
      }
      that.showLoading()
      this.$api.merchant.sysCommissionCheck({
        keywords: that.search.keywords
      }, function (res) {
        that.hideLoading()
        if (res.errcode === 0) {
          that.info = that.normalizeInfo(res.data)
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    normalizeInfo(data) {
      data = data || {}
      var listKeys = ['relations', 'integrals', 'commissions', 'orders', 'details', 'bills', 'refunds']
      listKeys.forEach(function (key) {
        if (!Array.isArray(data[key])) {
          data[key] = []
        }
      })
      data.summary = Object.assign({
        matched: 0,
        normal: 0,
        error: 0,
        warning: 0,
        status: 'normal'
      }, data.summary || {})
      return data
    },
    getList(key) {
      if (!this.info || !Array.isArray(this.info[key])) {
        return []
      }
      return this.info[key]
    },
    listLength(key) {
      return this.getList(key).length
    },
    sum(rows, key) {
      return rows.reduce(function (total, item) {
        return total + Number(item[key] || 0)
      }, 0)
    },
    money(value) {
      return Number(value || 0).toFixed(2)
    },
    handleSearch() {
      this.getInfo()
    },
    summaryType(status) {
      return status === 'normal' ? 'success' : (status === 'warning' ? 'warning' : 'danger')
    },
    summaryText(status) {
      return status === 'normal' ? '整体正常' : (status === 'warning' ? '有提示' : '存在异常')
    }
  }
};
</script>

<style scoped>
.commission-check {
  color: #303133;
}

.keyword-input {
  width: 420px;
}

.account-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding: 12px 0;
}

.account-header h2 {
  margin: 2px 0 0;
  font-size: 18px;
}

.eyebrow {
  color: #909399;
  font-size: 12px;
}

.flow-board {
  display: grid;
  grid-template-columns: 1fr 32px 1fr 32px 1fr 32px 1fr;
  align-items: stretch;
  margin-top: 6px;
}

.flow-step {
  min-height: 96px;
  padding: 14px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
}

.flow-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 22px;
}

.step-title {
  color: #606266;
  font-size: 13px;
}

.step-main {
  margin-top: 8px;
  color: #303133;
  font-size: 22px;
  font-weight: 700;
}

.step-sub {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.summary-card {
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;
}

.summary-card span {
  display: block;
  color: #909399;
  font-size: 12px;
}

.summary-card strong {
  display: inline-block;
  margin-top: 6px;
  font-size: 20px;
}

.summary-card em {
  margin-left: 4px;
  color: #909399;
  font-style: normal;
}

.section-block {
  margin-top: 18px;
}

.section-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.section-head h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.empty-panel {
  padding: 18px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  color: #909399;
  background: #fff;
}

.order-flow {
  margin-bottom: 12px;
  border: 1px solid #dcdfe6;
  border-left: 4px solid #67c23a;
  border-radius: 4px;
  background: #fff;
}

.order-flow.error {
  border-left-color: #f56c6c;
}

.order-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid #ebeef5;
}

.order-title {
  font-weight: 700;
}

.order-meta {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.order-lines {
  padding: 4px 14px 12px;
}

.money-line {
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 12px;
  padding-top: 10px;
}

.line-label {
  color: #606266;
  font-weight: 600;
}

.line-content {
  color: #303133;
}

.line-content strong {
  color: #409eff;
}

.muted,
.formula {
  display: block;
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.check-row {
  padding: 0 14px 12px;
}

.check-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.check-tag {
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.error-list {
  border: 1px solid #fbc4c4;
  border-radius: 4px;
  background: #fef0f0;
}

.error-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid #fbc4c4;
}

.error-item:last-child {
  border-bottom: 0;
}

.raw-collapse {
  margin-top: 18px;
}

.raw-section {
  margin-bottom: 12px;
}

.raw-title {
  margin-bottom: 6px;
  font-weight: 600;
}

.raw-section pre {
  max-height: 180px;
  margin: 0 0 8px;
  padding: 10px;
  overflow: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
  color: #606266;
  font-size: 12px;
}
</style>
